import { motion } from "framer-motion";
import { useMemo, useState } from "react";
import * as GrIcons from "react-icons/gr";
import { toast } from "react-toastify";
import CurrencyFormatter from "../../../../shared/currency-formatter";
import { useSelector } from "react-redux";
import { isStandardInurance } from "../../../../shared/currency-formatter/utils";
import { useTranslation } from "react-i18next";

function LoanTerms({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const tenantCreds = useSelector((state: any) => state.tenantCreds);
  const isStandard = useMemo(
    () => isStandardInurance(tenantCreds?.domain),
    [tenantCreds?.domain],
  );

  const p: any = sessionStorage.getItem("caculatedPlan") || {};

  const plan = JSON.parse(p);

  const policyDuration = sessionStorage.getItem("policyDuration");

  const [processing, setProcessing] = useState(false);
  const [termsInfo, setTermsInfo] = useState({
    terms: "",
  });

  const variants = {
    enter: (direction: number) => {
      return {
        x: direction < 0 ? 1000 : -1000,
        opacity: 0,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
  };

  const proceed = () => {
    if (!termsInfo.terms) {
      toast.warning(t("loanTerms.acceptTermsError"));
      return;
    }

    processPayment();
  };

  const processPayment = () => {
    if (isStandard) {
      sessionStorage.setItem("payment-screen", "payment-chapa");
      sessionStorage.setItem("payment-plan", "true");
      setCurrentScreen("payment-chapa");
      return;
    }
    sessionStorage.setItem("payment-screen", "payment-method");
    sessionStorage.setItem("payment-plan", "true");
    setCurrentScreen("payment-method");
  };

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setTermsInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div className="center-div"></div>
        <div className="reg-title text-center mb-2">
          <span className="span-title"> {t("loanTerms.title")}</span>
        </div>
        <br />
        <div className="confirmation-container">
          <div className="confirmation-wapper">
            <div className="mb-2 mt-3 loan-terms-border">
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">{t("loanTerms.loanType")}</span>
                <span className="ln-txt bold">
                  {t("loanTerms.loanTypeValue")}
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">{t("loanTerms.lender")}</span>
                <span className="ln-txt bold">
                  {t("loanTerms.lenderValue")}
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">{t("loanTerms.period")}</span>
                <span className="ln-txt bold">
                  {t("loanTerms.monthsCount", { count: plan.tenureInMonths })}
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">
                  {t("loanTerms.monthlyDeduction")}
                </span>
                <span className="ln-txt bold">
                  <CurrencyFormatter
                    value={plan.minimumPerUnitRepaymentAmount}
                    displayType={"text"}
                    suffix
                  />
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">
                  {t("loanTerms.monthlyInterestRate")}
                </span>
                <span className="ln-txt bold">{plan.interest}%</span>
              </div>
            </div>

            <div className="mb-2 mt-3 loan-terms-border">
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">
                  {t("loanTerms.totalInsurancePremium")}
                </span>
                <span className="ln-txt bold">
                  <CurrencyFormatter
                    value={plan.amount}
                    displayType={"text"}
                    suffix
                  />
                </span>
              </div>
              <hr />
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">{t("loanTerms.deposit")}</span>
                <span className="ln-txt bold">
                  <CurrencyFormatter
                    value={plan.downPaymentPayable}
                    displayType={"text"}
                    suffix
                  />
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">{t("loanTerms.loanAmount")}</span>
                <span className="ln-txt bold">
                  <CurrencyFormatter
                    value={plan.loanAmount}
                    displayType={"text"}
                    suffix
                  />
                </span>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="ln-txt">
                  {t("loanTerms.totalCostOfCredit")}
                </span>
                <span className="ln-txt bold">
                  <CurrencyFormatter
                    value={plan.totalCostOfCredit}
                    decimalScale={0}
                    suffix
                  />
                </span>
              </div>
              <hr />
              <div className="d-flex justify-content-between mt-1">
                <span className="con-amt-bld">
                  {t("loanTerms.totalPayable")}
                </span>
                <span className=" con-amt-bld">
                  <CurrencyFormatter
                    value={plan.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={0}
                    suffix
                  />
                </span>
              </div>
            </div>

            <h4 className="text-center text-primary mt-4">
              <span className="span-title">{t("loanTerms.loanSchedule")}</span>
            </h4>

            <div className="mb-2 mt-3 loan-terms-border">
              <div className="d-flex justify-content-between mt-1">
                <span className="bld-tit">{t("loanTerms.repaymentDate")}</span>
                <span className="bld-tit">
                  {t("loanTerms.installmentAmount")}
                </span>
              </div>
              <hr />
              {plan.schedule.map((item: any, index: any) => {
                return (
                  <div key={index}>
                    <div className="d-flex justify-content-between mt-1">
                      <span className="ln-txt">{item.date}</span>
                      <span className="ln-txt bold">
                        <CurrencyFormatter
                          value={item.amount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={0}
                        />
                      </span>
                    </div>
                    <hr />
                  </div>
                );
              })}

              <div className="d-flex justify-content-between mt-1">
                <span className="bld-tit">
                  {t("loanTerms.totalMonthlyPayments")}
                </span>
                <span className="con-amt-bld">
                  <CurrencyFormatter
                    value={plan.totalMonthlyRepayments}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={0}
                    suffix
                  />
                </span>
              </div>
            </div>

            <div className="mt-5">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                onChange={handleInputChange}
              />
              <span className="terrms-txt">
                {t("loanTerms.termsPrefix")}{" "}
                <a
                  target="_blank"
                  href="https://cdn.hillcroftinsurance.com/admin/TrustGro_IPF_Terms_and_Conditions_29112021.pdf"
                >
                  {t("loanTerms.termsLink")}
                </a>{" "}
                {t("loanTerms.termsSuffix")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5">
            <div className="previous">
              <span
                onClick={(e) => {
                  sessionStorage.setItem("payment-screen", "payment-schedule");
                  setCurrentScreen("payment-schedule");
                }}
              >
                <span className="GrIcon me-2">
                  <GrIcons.GrFormPreviousLink />
                </span>{" "}
                <span className="previous">{t("loanTerms.previous")}</span>
              </span>
            </div>
            <div className="" onClick={() => proceed()}>
              <button className="next-btn">
                {" "}
                <span>
                  {t("loanTerms.proceed")}{" "}
                  <span className="GrIcon ms-3">
                    <GrIcons.GrFormNextLink />
                  </span>
                </span>{" "}
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />
      </motion.div>
    </div>
  );
}

export default LoanTerms;
